import { useMemo, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { IResponseFilterSegment } from 'entities/Segment'
import { type IResponseGetSurvey } from 'entities/Surveys/api/types'
import { SurveySendModalStore } from 'widgets/SurveySend/store/SurveySendModalStore'
import { SurveySendModalFilters } from './SurveySendModalFilters'
import { SurveySendModalSearch } from './SurveySendModalSearch'
import styles from './styles.module.scss'

type ISurveySendModalProps = {
  contactIds?: number[]
  filtersList?: IResponseFilterSegment[]
  search?: string
  bulkAll?: boolean
  onClose: () => void
}

export const SurveySendModal = observer(
  ({ contactIds, filtersList, search, bulkAll, onClose }: ISurveySendModalProps) => {
    const store = useMemo(() => new SurveySendModalStore(), [])
    const [survey, setSurvey] = useState<IResponseGetSurvey | null>(null)
    const [applyFilters, setApplyFilters] = useState<boolean>(false)
    const [loading, setLoading] = useState(false)

    const sendDisabled = !survey

    const handleSend = () => {
      if (!survey) return

      setLoading(true)

      if (contactIds) {
        store
          .enrollContacts({
            surveyId: survey.id,
            contactIds,
            applyFilters,
          })
          .then((success) => {
            setLoading(false)
            if (success) onClose()
          })
      } else {
        store
          .enrollContactsByFilters({
            surveyId: survey.id,
            applyFilters,
            filtersList,
            search,
            bulkAll,
          })
          .then((success) => {
            setLoading(false)
            if (success) onClose()
          })
      }
    }

    return (
      <div className={styles.content}>
        <div className={styles.contentRows}>
          <div className={styles.contentRow}>
            <span className={styles.contentRowTitle}>Survey</span>
            <SurveySendModalSearch onSelect={setSurvey} />
          </div>
          <div className={styles.contentRow}>
            <SurveySendModalFilters value={applyFilters} onChange={setApplyFilters} />
          </div>
        </div>
        <div className={styles.contentFooter}>
          <Button
            size='medium'
            text='Cancel'
            contained='secondary'
            disabled={loading}
            onClick={onClose}
          />
          <Button
            size='medium'
            text='Send'
            loading={loading}
            disabled={sendDisabled}
            onClick={handleSend}
          />
        </div>
      </div>
    )
  }
)
